import Bilibili from "./ThirdParty/Bilibili";
export * from "./types";
export var PresetChannelOptionMap = {
    bilibili: Bilibili,
};
